import { Check, MapPin, Camera, Home, ListChecks } from "lucide-react";

const FEATURES = [
  "Today's assigned tickets with priority order",
  "Turn-by-turn map routing to job site",
  "Full ticket details and contact info",
  "One-tap photo upload with GPS tag",
  "Add notes and field observations",
  "Start / stop job time tracking",
  "Complete ticket with required evidence checklist",
  "Works offline — syncs automatically when connected",
];

function Phone() {
  const tickets = [
    { id: "LOC-2391", a: "412 Peachtree St", st: "IN PROGRESS", c: "bg-[#FB923C]/20 text-[#FDBA74]", d: "#FB923C" },
    { id: "LOC-2390", a: "88 N Lawn Ave", st: "PENDING", c: "bg-[#F97316]/20 text-[#F97316]", d: "#F97316" },
    { id: "LOC-2389", a: "204 Elm Rd", st: "COMPLETE", c: "bg-[#22C55E]/20 text-[#22C55E]", d: "#22C55E" },
  ];

  return (
    <div className="relative mx-auto w-[280px] h-[580px] rounded-[44px] bg-[#000000] border-[10px] border-[#0a0a0a] shadow-[0_30px_80px_rgba(249,115,22,0.5)]">
      {/* notch */}
      <div className="absolute top-2 left-1/2 -translate-x-1/2 h-6 w-32 rounded-full bg-[#000000] border border-white/5 z-10" />
      <div className="h-full w-full rounded-[34px] bg-[#0a0a0a] p-4 overflow-hidden flex flex-col">
        <div className="mt-7 flex items-center justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-[#94A3B8]">Today</div>
            <div className="font-display font-bold text-white text-lg">6 Tickets</div>
          </div>
          <div className="h-8 w-8 rounded-full bg-[#F97316]/20 border border-[#F97316]/30 grid place-items-center">
            <span className="text-[#F97316] text-xs font-bold">MT</span>
          </div>
        </div>

        <div className="mt-4 space-y-2.5 overflow-hidden">
          {tickets.map((t) => (
            <div key={t.id} className="rounded-xl bg-[#000000] border border-white/5 p-3">
              <div className="flex items-center justify-between mb-1.5">
                <span className="font-mono text-xs text-white">{t.id}</span>
                <span className="h-2 w-2 rounded-full" style={{ backgroundColor: t.d }} />
              </div>
              <div className="text-xs text-white">{t.a}</div>
              <div className="mt-2 flex items-center justify-between">
                <span className={`status-pill ${t.c}`}>{t.st}</span>
                <span className="text-[10px] text-[#94A3B8] font-mono">2.4 mi</span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom nav */}
        <div className="mt-auto mb-1 grid grid-cols-4 gap-1 pt-3 border-t border-white/5">
          {[
            { Icon: Home, l: "Home", a: true },
            { Icon: MapPin, l: "Map" },
            { Icon: Camera, l: "Photos" },
            { Icon: ListChecks, l: "Done" },
          ].map((n) => (
            <div key={n.l} className="flex flex-col items-center gap-1">
              <n.Icon size={16} className={n.a ? "text-[#F97316]" : "text-[#94A3B8]"} />
              <span className={`text-[9px] ${n.a ? "text-white" : "text-[#94A3B8]"}`}>{n.l}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function FieldApp() {
  return (
    <section data-testid="field-app-section" className="section-y relative">
      <div className="absolute right-0 top-1/3 w-96 h-96 rounded-full bg-[#F97316] mix-blend-screen blur-[160px] opacity-15 pointer-events-none" />
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] gap-12 items-center">
          <div className="reveal">
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Field App</div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
              Give locators one simple app for the workday.
            </h2>
            <p className="mt-5 text-lg text-[#94A3B8] leading-relaxed">
              No training manual required. One screen. Everything they need to start, work, and close tickets.
            </p>
            <ul className="mt-8 space-y-3">
              {FEATURES.map((f) => (
                <li key={f} className="flex items-start gap-3 text-white/90">
                  <span className="h-5 w-5 rounded-md bg-[#22C55E]/15 border border-[#22C55E]/30 grid place-items-center shrink-0 mt-0.5">
                    <Check size={12} className="text-[#22C55E]" />
                  </span>
                  <span className="text-sm">{f}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="reveal relative animate-float-slow">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#FB923C]/40 to-[#F97316]/30 blur-3xl rounded-full" />
            <div className="relative">
              <Phone />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
